// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
import ___CSS_LOADER_URL_IMPORT_0___ from "../../assets/star.svg";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".L2U8M {\n  border-radius: var(--schoolinks-container-border-radius);\n}\n\n.VtbWp {\n  background-color: var(--color-violet-extra-light);\n}\n\n.A\\+QQ9 {\n  background-color: var(--color-teal-extra-light);\n}\n\n.hcaHf {\n  -webkit-mask-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");\n          mask-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");\n  width: var(--schoolinks-icon-xl);\n  height: var(--schoolinks-icon-xl);\n}\n\n.a9wtW {\n  background-color: var(--color-violet);\n}\n\n.Dgtxz {\n  background-color: var(--color-teal);\n}\n\n.DPmdd {\n  border: var(--border-default-gray-light);\n  border-radius: var(--schoolinks-container-border-radius);\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n\n.K2MFE {\n  /* Add small padding to align button text for add and export */\n  padding-right: 18px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statContainer": "L2U8M",
	"violet": "VtbWp",
	"teal": "A+QQ9",
	"star": "hcaHf",
	"violetStar": "a9wtW",
	"tealStar": "Dgtxz",
	"actionContainer": "DPmdd",
	"offsetButton": "K2MFE"
};
export default ___CSS_LOADER_EXPORT___;
